import styled from "styled-components";

export const MainLayoutWrapper = styled.div`
    background: ${props => props.theme.palette.background};
    
 `;